import { Forbidden } from '../Forbidden';
import { ClassifierForm } from './form/ClassifierForm';
import {
  defaultClassifierFormData,
  PermissionCode,
  useHasPermission,
} from '@atlas-frontend/sdk';
import { useNavigateTo } from '../../paths/useNavigateTo';
import { path } from '../../paths';

export const ClassifierCreate = () => {
  const navigateToClassifierDirectory = useNavigateTo(path.classifierDirectory);

  return (
    <Forbidden isAllowed={useHasPermission(PermissionCode.CLASSIFIER_MANAGE)}>
      <ClassifierForm
        mode="create"
        defaultValues={defaultClassifierFormData}
        onClickCancel={() => navigateToClassifierDirectory()}
      />
    </Forbidden>
  );
};
